import { PropsWithChildren } from 'react';

import { Alert as ChakraAlert, AlertDescription, AlertIcon, BoxProps, CloseButton } from '@chakra-ui/react';
import { CancelIcon, CheckedIcon, InfoIcon, WarningIcon } from '@udacity/chakra-uds-icons';

export type AlertStatus = 'success' | 'error' | 'warning' | 'info';

export function Alert({
  status,
  closeable,
  children,
  onClose,
  ...rest
}: PropsWithChildren<{ status?: AlertStatus; closeable?: boolean; onClose?: () => void } & BoxProps>) {
  return (
    <ChakraAlert status={status} variant='v2' {...rest}>
      <AlertIcon>{iconMap.get(status)}</AlertIcon>
      <AlertDescription>{children}</AlertDescription>
      {closeable && <CloseButton onClick={onClose} />}
    </ChakraAlert>
  );
}

const iconMap = new Map();
iconMap.set('success', <CheckedIcon h='24px' w='24px' />);
iconMap.set('error', <CancelIcon h='24px' w='24px' />);
iconMap.set('warning', <WarningIcon h='24px' w='24px' />);
iconMap.set('info', <InfoIcon h='24px' w='24px' />);
